import { useEffect } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import Navbar from './Navbar'
import Footer from './Footer'
import WhatsAppButton from '../ui/WhatsAppButton'

export default function MainLayout() {
  const location = useLocation();

  // Resetear el scroll a la parte superior cada vez que cambie la ruta
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <Navbar />
      <WhatsAppButton />
      
      {/* Añadimos un padding-top para compensar el header fixed (h-20) */}
      <main className="flex-1 mt-20">
        <div key={location.pathname} className="animate-fadeIn">
          <Outlet />
        </div>
      </main>

      <Footer />
    </div>
  )
}